import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// List of supported languages
const supportedLanguages = ['en', 'de', 'fr', 'es', 'ja', 'ar', 'tu', 'ch', 'pt']

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// Get the stored language or default to English
const storedLang = localStorage.getItem('lang')
const defaultLocale = supportedLanguages.includes(storedLang) ? storedLang : 'en'

export default new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
})